import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'

@Component({
  selector: 'app-tooltip-column-renderer',
  template: ` <span title="{{ renderTitle() }}">{{ params.value }}</span> `,
  standalone: false
})
export class TooltipColumnRendererComponent implements AgRendererComponent {
  params: any

  agInit(params: any): void {
    this.params = params
  }

  refresh(params: any): boolean {
    return false
  }

  renderTitle() {
    const roles = this.params.data.CreatedByRoles
    if (roles) {
      return `${this.params.value} (${roles})`
    }

    return this.params.value
  }
}
